import { _js } from '@ifixit/localize';
import * as React from 'react';
import { Undo } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const UndoButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().undo().run()}
         isDisabled={!editor.can().undo()}
         icon={<Undo />}
         title={_js('Undo')}
         shortcut={'z'}
      ></TiptapButton>
   );
};
